import React from 'react';
import Typography from '../../../../StyledTypography';
import FieldWrapper from '../../fields/FieldWrapper';
import HelperText from '../../fields/HelperText';
import SignatureCanvas from '../../fields/SignatureCanvas';
import styles from '../IDSField.module.css';

const SignatureFieldInput = ({
  label,
  value,
  onChange,
  disabled,
  required,
  columnStyle,
  helperText,
  showError,
}) => {
  return (
    <FieldWrapper style={columnStyle}>
      <Typography variant="bodySmall" className={styles.fieldLabel}>
        {label}
        {required && <span className={styles.requiredIndicatorRed}> *</span>}
      </Typography>
      <SignatureCanvas value={value} onChange={onChange} disabled={disabled} />
      <HelperText text={helperText} error={showError} />
    </FieldWrapper>
  );
};

export default SignatureFieldInput;
